import apiClient from '@/services/axios'
import config from '@/configs'

// tasks functions
// get all tasks
export async function fetchTasks() {
  return apiClient
    .get(config.api.pm.tasks)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Tasks API]:', err))
}

// get tasks by query
export async function fetchTasksByQuery(query) {
  return apiClient
    .post(`${config.api.pm.tasks}/query`, query)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Tasks API]:', err))
}

// get a task by id
export async function fetchTaskById(id) {
  return apiClient
    .get(`${config.api.pm.tasks}/${id}`)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Tasks API]:', err))
}

// get tasks by user id
export async function fetchTasksByUser() {
  return apiClient
    .get(`${config.api.pm.tasks}/user`)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Customers API]:', err))
}

// get tasks by project id
export async function fetchTasksByProjectId(id) {
  return apiClient
    .get(`${config.api.pm.tasks}/project/${id}`)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Customers API]:', err))
}

// create a new task
export async function createTask(task) {
  return apiClient
    .post(config.api.pm.tasks, task)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Tasks API]:', err))
}

// update a task
export async function updateTask(task) {
  return apiClient
    .put(config.api.pm.tasks, task)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[PM/Tasks API]:', err))
}
